import { useQuery } from '@tanstack/react-query';
import { getProjetEtapes } from '../../api/PROJETS/projets';

export const useGetProjetEtapes = (id) => {
  return useQuery({
    queryKey: ['projetEtapes', id],
    queryFn: () => getProjetEtapes(id),
    enabled: !!id,
    staleTime: 2 * 60 * 1000,
    retry: false,
  });
};
